module.exports = __webpack_public_path__ + "assets/logo_pollotron.e9851c12.svg";